export default __webpack_public_path__ + "static/media/photo--sm--7.9ae67fe2.jpg";